import styled from 'styled-components';
import { SecondaryButton } from '../../../../components/Button';

export const MenuWrapper = styled.div`
  background-color: #ffffff;
  height: fit-content;
  padding: 16px 16px 8px 16px;
  border-radius: 8px;
  width: max-content;
  box-shadow: 0px 0px 15px 0px #0000001a;

  button {
    outline: none;
    width: 100%;
    background-color: transparent;
    cursor: pointer;
    border: none;
    border-bottom: 1px solid #dbdbdb;
    justify-content: flex-start;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid #dbdbdb;
  padding: 2px 0;

  &:last-child {
    border-bottom: 0;
  }
`;

export const ItemName = styled.p`
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #545454;
`;

export const List = styled.div`
  padding: 12px 0;
  display: flex;
  align-items: center;
  gap: 6px;
  /* width: max-content;
  border: none;
  height: auto;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #545454; */
`;

export const PopupWrapper = styled.div``;

export const Header = styled.div`
  display: flex;
  justify-content: flex-end;

  svg {
    cursor: pointer;
  }
`;
export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px 24px;

  @media screen and (max-width: 600px) {
    padding: 0;
    justify-content: flex-start;
  }
`;

export const ShareHeading = styled.p`
  font-family: Noto Sans;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  color: #038ae3;
  margin-bottom: 16px;

  @media screen and (max-width: 600px) {
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 8px;
  }
`;

export const ShareSubHeading = styled.p`
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000000;
  text-align: center;

  @media screen and (max-width: 600px) {
    font-size: 12px;
    line-height: 18px;
    text-align: left;
  }
`;

export const ShareActionsWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  gap: 12px;

  @media screen and (max-width: 600px) {
    margin-top: 14px;
    justify-content: flex-start;
  }
`;
export const CircleWrapper = styled.a`
  min-height: 48px;
  min-width: 48px;
  max-height: 48px;
  max-width: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 600px) {
    min-height: 32px;
    min-width: 32px;
    max-height: 32px;
    max-width: 32px;

    svg {
      width: 32px;
      height: 32px;
    }
  }
`;

export const BottomWrapper = styled.div`
  height: 32px;
  margin-top: 16px;

  @media screen and (max-width: 600px) {
    height: 18px;
    margin-top: 16px;
    display: flex;
    justify-content: center;
    align-items: end;
  }
`;

export const CopiedText = styled.p`
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 29px;
  color: #038ae3;
  text-align: center;

  @media screen and (max-width: 600px) {
    font-size: 10px;
    line-height: 12px;
  }
`;

export const Body = styled.div`
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.75;
  color: var(--Text500);
  margin-top: 16px;
`;

export const HeadTitleText = styled.p`
  font-family: Noto Sans;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  text-align: left;
  color: #ffffff;
`;
export const PreviewHeadWrapper = styled.div`
  background-color: #38a1e8;
  padding: 24px;
`;

export const CopyLinkWrapper = styled.div`
  border: 1px solid #038ae3;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  p {
    font-family: Noto Sans;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    color: #038ae3;
  }

  @media screen and (max-width: 600px) {
    border-radius: 24px;

    p {
      font-family: Noto Sans;
      font-size: 8px;
      font-weight: 700;
      line-height: 12px;
      color: #038ae3;
    }

    svg {
      height: 14px;
      width: 14px;
    }
  }
`;
